import { useCallback, useMemo, useState } from 'react';
import { DbIdsPerModel } from '../../../common/ForgeViewer';

export type SheetsColorizationManager = {
  colorization: {
    colorFunc: (urn: string, dbId: number) => string;
    dbIdsPerModel: DbIdsPerModel;
  } | null;
  colorSection: (
    colorFunc: (urn: string, dbId: number) => string,
    dbIdsPerModel: DbIdsPerModel
  ) => void;
  clearColors: () => void;
};

/**
 * Hook for managing colorization of elements in the Sheet viewer.
 * If you want colorization for all elements, including sheet elements, consider [colorization.ts](../../services/viewer/colorization.ts)
 */
export const useSheetsColorization = (): SheetsColorizationManager => {
  const [colorization, setColorization] = useState<{
    colorFunc: (urn: string, dbId: number) => string;
    dbIdsPerModel: DbIdsPerModel;
  } | null>(null);

  const colorSection = useCallback(
    (
      colorFunc: (urn: string, dbId: number) => string,
      dbIdsPerModel: DbIdsPerModel
    ) => {
      setColorization({
        colorFunc,
        dbIdsPerModel,
      });
    },
    []
  );

  const clearColors = useCallback(() => {
    setColorization(null);
  }, []);

  return useMemo(
    () => ({
      colorization,
      colorSection,
      clearColors,
    }),
    [clearColors, colorSection, colorization]
  );
};
